module.exports = ".recollection {\r\n  min-height: 350px;\r\n}\r\n"